import React from 'react';
import './BannerText.css';
// import {Container, Button} from 'react-bootstrap'
import Slide from 'react-reveal/Slide';
function BannerText() {

    window.addEventListener("scroll",function(){
        let banner__text = this.document.querySelector(".banner__text");
        banner__text.classList.add("appear",this.window.scrollY > 0)
    })

    return (
        <div className='banner__text'>
            <Slide top>
            
                <div className='banner__text__content'>

                    <h3>Welcome to Royal Smiles Dental Clinic GreenSpan</h3>
                    <h6>
                        Where we serve the prettiest smiles and make you look your best while at it.
                    </h6>

                    <a href='#contact' className='banner__text__btn'> Make Appointment</a>
                

                </div>
            </Slide>
                
            


        </div>
    );
}

export default BannerText;
